import React, { BaseSyntheticEvent, useState } from 'react';

// COMPONENTS
import Icon from '../Icon';

// ENUMS
import { Icons } from '../../enums/icons';
import { InputType } from '../../enums/inputType';

// INTERFACES
import { IToggleButton } from '../../interfaces/ToggleButton.interface';

// STYLES
import { Container, ToggleInput, ToggleIO } from './styles';

const ToggleButton: React.FC<IToggleButton> = ({ isChecked, onChange, isDisabled }) => {
  const [isCheckState, setCheckState] = useState(false);
  const handleOnChange = (e: BaseSyntheticEvent) => {
    if (!!onChange) {
      onChange(e);
    }
  };

  return (
    <Container>
      <ToggleInput
        type={InputType.CHECKBOX}
        onChange={!!onChange ? handleOnChange : () => setCheckState((prevState) => !!!prevState)}
        checked={isChecked ? isChecked : isCheckState}
        value={String(isChecked ? isChecked : isCheckState)}
        disabled={isDisabled}
      />
      <ToggleIO>
        <Icon type={Icons.CHECK_MARK} />
      </ToggleIO>
    </Container>
  );
};

export default ToggleButton;
